export default "__VITE_ASSET__YHYnxNyL__"